import * as React from 'react';
import * as moment from 'moment';
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock, Modal } from 'react-bootstrap'
import { IXmTracking } from '@nkr/models/index';
import MyDTPicker from '@nkr/components/date-time-picker-with-close-button';

interface IProps {
    show: boolean,
    data: IXmTracking,
    title: string,
    onSubmit: (trackingNumber: string, shippedDate: string) => void,
    onCancel: () => void
}

const MarkShippedOut = (props: IProps) => {
    const [trackingNumber, setTrackingNumber] = React.useState('');
    const [shippedDate, setShippedDate] = React.useState(moment().format('MM/DD/YYYY HH:mm'));
    const [validTrackingNumber, setValidTrackingNumber] = React.useState(true);
    const [validShippedDate, setValidShippedDate] = React.useState(true);
    const [dirty, setDirty] = React.useState(false);

    const handleTrackingNumberChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        setTrackingNumber(e.currentTarget.value);
    };

    const handleShippedDateChange = (value: moment.Moment | string) => {
        let v = typeof (value) == 'string' ? value : value.format('MM/DD/YYYY HH:mm');
        setShippedDate(v);
    };

    const handleSubmit = () => {
        let isValidTrackingNumber = trackingNumber != '';
        let isValidShippedDate = moment(shippedDate).isValid();

        if (isValidTrackingNumber && isValidShippedDate) {
            props.onSubmit(trackingNumber, shippedDate);
        } else {
            setValidTrackingNumber(isValidTrackingNumber);
            setValidShippedDate(isValidShippedDate)
            setDirty(true);
        }
    }

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup validationState={dirty && !validTrackingNumber ? 'error' : null}>
                    <ControlLabel>Tracking #</ControlLabel>
                    <FormControl
                        value={trackingNumber}
                        onChange={handleTrackingNumberChange}
                    />
                    {dirty && !validTrackingNumber && (
                        <HelpBlock>This is required</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={dirty && !validShippedDate ? 'error' : null}>
                    <ControlLabel>Shipped Date/Time</ControlLabel>
                    <MyDTPicker
                        value={shippedDate}
                        useCloseButton={true}
                        dateFormat={'MM/DD/YYYY'}
                        timeFormat={'HH:mm'}
                        onChange={handleShippedDateChange}
                    />
                    {dirty && !validShippedDate && (
                        <HelpBlock>This is required</HelpBlock>
                    )}
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Submit</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MarkShippedOut;